import type { UserRole } from '@helpers/types';

export interface FetchLoginUserBody {
  userName: string;
  password: string;
}

export const fetchLoginUser = async (callData: FetchLoginUserBody) => {
  const body: FetchLoginUserBody = {
    ...callData
  };

  const response = await fetch('api/v1/user', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    credentials: 'include'
  });

  if (!response.ok) {
    // Throw error so SWR can catch and store it
    throw new Error(`Login failed with error: ${response.statusText}`);
  }

  return (await response.json()) as {
    success: boolean;
    data: {
      userName: string;
      avatarUrl: string;
      socialUrl: string;
      role: UserRole;
    };
  };
};
